export default "__VITE_ASSET__ChHXHmln__"